<template>
  <div class="foot-box">
    <button class="default-btn" :class="invalid?'':'disabled-btn'" @click="emitPlayAgain" :invalid="checkStatus">重来一遍</button>
    <button class="default-btn" @click="emitBackMission">返回本关首页</button>
    <button class="default-btn" @click="emitBackActivities">返回活动广场</button>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
export default {
  props: {
    id: Number
  },
  name: 'FootBox',
  data(){
    return {
      invalid:true
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo
    }),
    checkStatus(){
      let invalid=true
      let b = this.shengyaUser.admin.endDate
      let day = moment(b).diff(moment().format(), 'days')
      if(this.shengyaUser.arrCosPlay[this.id-1]==1&&day<0){
        invalid= false
      }
      this.invalid = invalid
      return invalid
    }
  },
  methods: {
    //重玩一遍
    emitPlayAgain() {
      if(this.invalid){
        this.$bus.$emit('play-again')
      }else{
        this.$store.commit('showMessage', {
          message: '已过有效期，暂不能使用该功能',
          type: 'warning',
          duration:4000
        })
      }
    },
    //返回本关首页
    emitBackMission() {
      this.$bus.$emit('back-mission')
    },
    //返回广场
    emitBackActivities() {
      // this.$store.dispatch('quitMissionGroup',this.id)
      this.$bus.$emit('back-activities')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .foot-box
    padding: 0.2rem 0;
    position: fixed;
    max-width: 12rem;
    width: 100%;
    bottom: 0;
    background: #f5f5f5;
</style>
